import React from 'react';

import { IBlurb } from 'components/Contentful/Blurb';
import { IMarkdownWrapperProps } from 'components/MarkdownWrapper/MarkdownWrapper';
import { IDetailedPromotion } from 'hooks/ProgramPromotion/useProgramPromotion';
import { TextV2 } from 'components/TextV2/TextV2';

type BlurbProps = Partial<Omit<IBlurb<any>, 'entry' | 'field'> & IMarkdownWrapperProps<any>> & {
  children?: never;
};

type BannerTextProps = BlurbProps & {
  currentPromotion?: IDetailedPromotion;
  blurb?: string;
};

export const BannerText: React.FC<BannerTextProps> = ({ blurb, currentPromotion }) => {
  const bannerText = blurb ?? currentPromotion?.promotionLongDescription;

  if (!bannerText) return null;

  return <TextV2 value={bannerText} variant="modern-nav-link" />;
};
